export class BaseResponseModel {
    constructor(obj) {
        this.AccessKey = obj.AccessKey;
        this.RequestKey = obj.RequestKey;
        this.ResultCode = obj.ResultCode;
        this.ResultSubCode = obj.ResultSubCode;
        this.UserTitle = obj.UserTitle;
        this.UserMessage = obj.UserMessage;
        this.DetailMessage = obj.DetailMessage;
    }
}